import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import UpdateEntryForm from './form'

const UpdateEntryDialog = React.forwardRef(function UpdateEntryDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (entry) => setDialogState({ open: true, processing: false, entry })
  }), [setDialogState])

  return (
    <RoundedModal
      title='Update Entry'
      open={dialogState.open}
      onClose={close}
      position='top'
      size='large'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (<UpdateEntryForm entry={dialogState.entry} onComplete={handleComplete} onCancel={close} />) : null}
      </div>
    </RoundedModal>
  )
})

UpdateEntryDialog.propTypes = {
  onComplete: PropTypes.func
}

UpdateEntryDialog.defaultProps = {
  onComplete: () => {}
}

export default UpdateEntryDialog
